import { untypedIsEnabled } from '@ip-only/client-features';
import { environment } from '../../../environments/environment';
import { isTopLevelDomainFI } from '../../shared/util/deploy-helper';

export const isMduEnabled = (): boolean =>
  untypedIsEnabled('mdu') &&
  !(environment.productionEnv && isTopLevelDomainFI());
